module.exports = __webpack_public_path__ + "static/media/VectorSurv_Icon.f6943cce.svg";